/**
 * Inline SVG icons.
 *
 * Inline rather than an icon font or package: there are eight of them, they
 * inherit `currentColor` so they follow the button they sit in, and it keeps
 * the bundle free of a dependency that would ship several hundred unused
 * glyphs. `aria-hidden` throughout — every icon here sits beside a text label,
 * so none of them carries meaning on its own.
 */

const base = {
    width: 15,
    height: 15,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    "aria-hidden": true,
    focusable: false,
};

export const HomeIcon = () => (
    <svg {...base} width={14} height={14}>
        <path d="M3 10.5 12 3l9 7.5" />
        <path d="M5 9.5V20h14V9.5" />
    </svg>
);

export const ChevronRight = ({ size = 14 }: { size?: number }) => (
    <svg {...base} width={size} height={size}>
        <path d="M9 6l6 6-6 6" />
    </svg>
);

export const ChevronLeft = ({ size = 14 }: { size?: number }) => (
    <svg {...base} width={size} height={size}>
        <path d="M15 6l-6 6 6 6" />
    </svg>
);

export const FilterIcon = () => (
    <svg {...base}>
        <path d="M3 5h18l-7 8v6l-4-2v-4z" />
    </svg>
);

export const DownloadIcon = () => (
    <svg {...base}>
        <path d="M12 3v12" />
        <path d="M7 11l5 5 5-5" />
        <path d="M4 20h16" />
    </svg>
);

export const SearchIcon = () => (
    <svg {...base} width={14} height={14}>
        <circle cx="11" cy="11" r="7" />
        <path d="M20 20l-4.3-4.3" />
    </svg>
);

export const CloseIcon = ({ size = 13 }: { size?: number }) => (
    <svg {...base} width={size} height={size}>
        <path d="M6 6l12 12M18 6L6 18" />
    </svg>
);

export const RefreshIcon = () => (
    <svg {...base}>
        <path d="M20 12a8 8 0 1 1-2.3-5.7" />
        <path d="M20 4v5h-5" />
    </svg>
);
